import { useEffect, useState } from "react"
import getConfig from "config"

export type RetryConfig = {
  maxAttempts?: number
  delayMs?: number
}

export type ElectronConfig = {
  url?: string
  device_location?: string
  device_name?: string
  header_image?: string // TODO: replace with kiosk config?
  header_image_overlap?: boolean
  footer_image?: string
  footer_image_overlap?: boolean // Allows the header image to overlap the kiosk app header — useful when you want to replace the entire app header.
  home_footer_image?: string
  device_view_point?: string
  retry?: RetryConfig
}

export type IUseElectronConfig = () => {
  config: ElectronConfig | null
}

export const useElectronConfig: IUseElectronConfig = () => {
  const [config, setConfig] = useState<ElectronConfig | null>(null)
  // To remember the latest callback .
  useEffect(() => {
    const electron = window.electron
    if (electron) {
      const initSetting = async () => {
        const setting = await window.electron.invoke<
          any,
          ElectronConfig | null
        >("getSettingsData")
        if (setting) {
          setConfig(setting)
          if (getConfig("env") === "development")
            console.log("Electron - Setting up React configuration:", setting)
        }
      }
      initSetting()
    }
  }, [])

  return { config }
}
